import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Directive({
  selector: '[appCanAction]',
  standalone: true,
})
export class CanActionDirective {
  private originalDisplay: string | null = null;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private authService: AuthService
  ) { }

  @Input()
  set appCanAction(value: number | number[] | null | undefined) {
    const actionIds = Array.isArray(value) ? value : value ? [value] : [];
    this.updateVisibility(actionIds);
  }

  private updateVisibility(actionIds: number[]): void {
    const nativeElement = this.elementRef.nativeElement;
    const canShow = this.authService.hasAnyAction(actionIds);

    if (this.originalDisplay === null) {
      this.originalDisplay = nativeElement.style.display || '';
    }

    this.renderer.setStyle(nativeElement, 'display', canShow ? this.originalDisplay : 'none');
  }
}
